import Card from '@/global/components/Card'
import { CardRadioForm, FormField } from '@/global/components/Form'
import Grid from '@/global/components/ui/Grid'
import { TrocaInicioPonto } from '@/service/api'
import { ArrowRightIcon } from 'lucide-react'
import { useFormContext } from 'react-hook-form'
import { useEditarEmpresaOutletContext } from '../../../modals/Editar'
import EdicaoSlider from './EdicaoSlider'

type Opcao = 'registrar' | 'corrigir'

interface IProps {
    trocasInicioPonto: TrocaInicioPonto[]
    onValidityChange: (valido: boolean) => void
}

export default function FormAlterarInicioPonto({
    trocasInicioPonto,
    onValidityChange,
}: IProps) {
    const {
        data: { diaInicioPonto = 1 },
    } = useEditarEmpresaOutletContext()
    const { watch } = useFormContext()
    const opcao = watch('_opcao') as Opcao

    return (
        <Grid container className="pb-16">
            <Grid item xs={12}>
                <CardRadioForm
                    label="O que deseja fazer?"
                    name="_opcao"
                    options={[
                        {
                            titulo: 'Só corrigir o dia',
                            descricao: 'Apenas altera o dia de início do ponto',
                            value: 'corrigir',
                        },
                        {
                            titulo: 'Mudar e registrar',
                            descricao: 'Registra uma troca de início do ponto',
                            value: 'registrar',
                        },
                    ]}
                />
            </Grid>

            {opcao === 'corrigir' && (
                <Grid item xs={6} sm={4}>
                    <FormField
                        name="diaInicioPonto"
                        label="Novo dia de início do ponto"
                        variant="filled"
                        type="number"
                        required
                        min={1}
                        max={31}
                        autoComplete="off"
                        startAdornment={
                            <div className="inline-flex items-center text-primary">
                                {diaInicioPonto}{' '}
                                <ArrowRightIcon className="size-4 mx-2" />
                            </div>
                        }
                    />
                </Grid>
            )}

            {opcao === 'registrar' && (
                <>
                    <Grid item xs={4}>
                        <FormField
                            name="diaAnterior"
                            label="Dia de início da competência anterior"
                            variant="filled"
                            type="number"
                            required
                            min={1}
                            max={31}
                        />
                    </Grid>
                    <Grid
                        item
                        xs={1}
                        className="flex items-baseline justify-center mt-3"
                    >
                        <ArrowRightIcon className="size-8 text-primary" />
                    </Grid>
                    <Grid item xs={4}>
                        {' '}
                        <FormField
                            name="diaInicioPonto"
                            label="Novo dia de início do ponto"
                            variant="filled"
                            type="number"
                            required
                            min={1}
                            max={31}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <Card>
                            <EdicaoSlider
                                trocasInicioPonto={trocasInicioPonto}
                                onValidityChange={onValidityChange}
                            />
                        </Card>
                    </Grid>
                </>
            )}
        </Grid>
    )
}
